import { CarrierRef } from '@rygen/rygen-ui/model';

import { RateProviderDetails } from './RateProviderDetails';

export class BrokerRateProviderDetails implements RateProviderDetails {
  brokeredCarrier?: CarrierRef;

  constructor(opts?: Partial<BrokerRateProviderDetails>) {
    if (opts?.brokeredCarrier != null) {
      this.brokeredCarrier = new CarrierRef(opts.brokeredCarrier);
    }
  }
}
